angular
.module('vppApp')
.controller('familyLegacyController', familyLegacyController);

familyLegacyController.$inject = ['$scope', '$rootScope', 'DTMTrackerService'];

function familyLegacyController($scope, $rootScope, DTMTrackerService) {
  DTMTrackerService.updatePageLoadData('pageType', 'family legacy');
};
